import React, { useState } from "react";
import {
  Card,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Box,
  Typography,
  makeStyles,
  IconButton,
  Menu,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  TableContainer,
} from "@material-ui/core";

import {
  Menu as MenuIcon,
  Refresh,
  Close as CloseIcon,
} from "@material-ui/icons";
import { DataGrid } from "@material-ui/data-grid";
import HighStock from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import ReportsOptions from "../../Reports/ReportsOptions";
import DatePickerTab from "../../../components/Tabs/DatePickerTab";
import moment from "moment";
const contextFields = [
  {
    key: "_id",
    label: "ID",
  },
  {
    key: "is_binary",
    label: "Binary Sensor",
  },
  {
    key: "is_reported",
    label: "Reported",
  },
  {
    key: "is_cumulative",
    label: "Cumulative",
  },
  {
    key: "is_reset_daily",
    label: "Daily Reset Enabled",
  },
  {
    key: "daily_resets_at",
    label: "Daily Reset Time",
  },
  {
    key: "daily_reset_timezone",
    label: "Reset Timezone",
  },
  {
    key: "count_object",
    label: "Count Object",
  },
  {
    key: "report_algorithm",
    label: "Report Algorithm",
  },
  {
    key: "type",
    label: "Report Type",
  },
];
const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: 12,
    overflow: "hidden",
    // height: "100%",
    // height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    padding: theme.spacing(3),
    background: "linear-gradient(180deg, #e8f4f8 0%, #d9eef3 100%)",
    borderBottom: "4px solid #0076bb",
  },
  title: {
    color: "#0076bb",
    fontWeight: 700,
  },
  dataGridContainer: {
    padding: 16,
    // flex: 1,
    // minHeight: "400px", // important when inside a flex layout
  },
  contextTable: {
    "& .MuiTableCell-root": {
      borderBottom: "1px solid #e0e0e0",
      padding: theme.spacing(1.5),
    },
  },
  keyCell: {
    fontWeight: 600,
    color: "#0076bb",
    width: "40%",
    backgroundColor: "#f5f9fb",
  },
  valueCell: {
    color: "#333",
  },
}));

const ContextTable = ({ context }) => {
  const classes = useStyles();

  if (!context) return null;

  const formatValue = (key, value) => {
    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }

    if (key === "count_object") {
      return value.replaceAll("_", " ");
    }

    return value || "-";
  };

  return (
    <TableContainer component={Paper}>
      <Table size="small" className={classes.contextTable}>
        <TableBody>
          {contextFields.map(({ key, label }) => (
            <TableRow key={key} hover>
              <TableCell className={classes.keyCell}>{label}</TableCell>

              <TableCell className={classes.valueCell}>
                {formatValue(key, context[key])}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default function AttributeInfoCard({
  sensors = [],
  chartData = [],
  changeHandler,
  optionsData,
}) {
  const columns = [
    { field: "reportDateTZ", headerName: "Date", flex: 1 },

    { field: "value", headerName: "Value", flex: 1 },
    {
      field: "context",
      headerName: "Context",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="outlined"
          size="small"
          onClick={(event) => {
            event.stopPropagation();
            handleContextOpen(params.row.context);
          }}
        >
          View Context
        </Button>
      ),
    },
  ];
  const [anchorEl, setAnchorEl] = useState(null);
  const [contextModal, setContextModal] = useState({
    open: false,
    context: null,
  });

  const handleContextOpen = (context) => {
    setContextModal({
      open: true,
      context,
    });
  };

  const handleContextClose = () => {
    setContextModal({
      open: false,
      context: null,
    });
  };

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleRefresh = () => {
    handleMenuClose();

    changeHandler({
      type: "refresh",
    });
  };
  const classes = useStyles();

  const [refresh, setRefresh] = useState(false);
  const [maxDate, setmaxDate] = useState(moment().tz("America/New_York"));

  const rows = sensors.map((sensor, index) => ({
    ...sensor,
    id: `${sensor.reportDateUNIX}-${sensor.value}-${index}`,
  }));

  const chartPoints = chartData.map((item) => [
    item.reportDateUNIX,
    item.value,
  ]);

  const options = {
    rangeSelector: {
      enabled: false,
    },

    navigator: {
      enabled: true,
      enabled: true,
    },

    scrollbar: {
      enabled: false,
    },

    title: {
      text: "Sensor Values",
    },

    xAxis: {
      type: "datetime",
    },

    yAxis: {
      title: {
        text: "Value",
      },
    },

    series: [
      {
        type: "line",
        name: "Sensor Value",
        data: chartPoints,
      },
    ],

    credits: {
      enabled: false,
    },
  };

  const hasSamplingOptions =
    Object.keys(optionsData.samplingOptions || {}).length > 0;
  return (
    <Card elevation={6} className={classes.card}>
      <Dialog
        open={contextModal.open}
        onClose={handleContextClose}
        disableBackdropClick
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Context Information
          <IconButton
            aria-label="close"
            onClick={handleContextClose}
            style={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <ContextTable context={contextModal.context} />
        </DialogContent>
      </Dialog>
      <Box className={classes.header}>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h5 className={classes.title}>Attribute Information</h5>
          <IconButton size="medium" onClick={handleMenuOpen}>
            <MenuIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={open}
            onClose={handleMenuClose}
            keepMounted
          >
            <MenuItem onClick={handleRefresh}>
              <Refresh fontSize="small" style={{ marginRight: 8 }} />
              Refresh
            </MenuItem>
          </Menu>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Box
              style={{
                display: "flex",
                alignItems: "end",
                height: "100%",
                padding: 8,
              }}
            >
              <DatePickerTab
                start={moment(optionsData.start)}
                end={moment(optionsData.end)}
                maxDate={maxDate}
                // ranges={ranges}
                callbackHandler={(start, end, rangeType) => {
                  changeHandler({
                    type: "dateChange",
                    params: {
                      start: start,
                      end: end,
                    },
                  });
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Aggregation Method:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={optionsData.aggregationMethod} displayEmpty>
                      {Object.entries(optionsData.aggregationOptions).map(
                        ([key, value], index) => {
                          return (
                            <MenuItem key={value} value={value}>
                              {key}
                            </MenuItem>
                          );
                        },
                      )}
                    </Select>
                  </FormControl>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Sampling Period:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  <FormControl variant="outlined" fullWidth>
                    <Select
                      value={optionsData.samplingPeriod ?? ""}
                      displayEmpty
                      disabled={!hasSamplingOptions}
                      renderValue={(selected) => {
                        if (!hasSamplingOptions) {
                          return "No options available";
                        }

                        if (!selected) {
                          return "Select Sampling Period";
                        }

                        return selected;
                      }}
                    >
                      {!hasSamplingOptions ? (
                        <MenuItem value="" disabled>
                          No options available
                        </MenuItem>
                      ) : (
                        Object.entries(optionsData.samplingOptions).map(
                          ([key, value]) => (
                            <MenuItem key={value} value={value}>
                              {key}
                            </MenuItem>
                          ),
                        )
                      )}
                    </Select>
                  </FormControl>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box className={classes.dataGridContainer}>
        <HighchartsReact
          highcharts={HighStock}
          constructorType="stockChart"
          options={options}
        />
        <DataGrid
          autoHeight
          rows={rows}
          columns={columns}
          disableColumnMenu
          pagination
          paginationMode="server"
          rowCount={optionsData.totalPages}
          disableSelectionOnClick
          page={optionsData.page}
          pageSize={optionsData.limit}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={(newpage) => {
            changeHandler({
              type: "pageChange",
              params: {
                newpage,
              },
            });
          }}
          onPageSizeChange={(newLimit) =>
            changeHandler({
              type: "limitChange",
              params: {
                newLimit,
              },
            })
          }
        />
      </Box>
    </Card>
  );
}
